<template>
	<main-container>
		<material-card icon="fas fa-book" :title="$t('incomedeclarations.table_title')" :exportElement="{ element: 'IncomeDeclarations', types: ['xls'] }" :main_action="main_action" @mainAction="newIncomeDeclarations" :selected="selected_incomedeclarations" @unselectAll="selected_incomedeclarations = []">
			<template slot="delete-actions">
				<v-btn icon link @click="deleteIncomeDeclarations()">
					<v-icon>far fa-trash-alt</v-icon>
				</v-btn>
			</template>
			<template slot="filters">
				<v-col cols="12" xs="12" sm="5">
					<search-box v-model="incomedeclarations_options.search" nocolor @change="incomedeclarations_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table @click-action="editIncomeDeclarations" :selected.sync="selected_incomedeclarations" show-select :headers="incomedeclarations_headers" :items="incomedeclarations.data" :options.sync="incomedeclarations_options" :server-items-length="incomedeclarations.total" :loading="incomedeclarations_loading">
				<template v-slot:item.date="{ item }">{{ $formatters.frontEndDateFormat(item.date) }}</template>
				<template v-slot:item.tax="{ item }">{{ $formatters.formatCurrency(item.tax) }}</template>
				<template v-slot:item.contribute="{ item }">{{ $formatters.formatCurrency(item.contribute) }}</template>
				<template v-slot:item.taxable="{ item }">{{ $formatters.formatCurrency(item.taxable) }}</template>
				<template v-slot:item.attachments="{ item }">
					<v-badge :value="$functions.attachmentsCount(item) != 0" color="secondary" overlap right :content="$functions.attachmentsCount(item)" v-if="$functions.attachmentsCount(item) != 0">
						<v-btn icon small @click.stop="showIncomeDeclarationsAttachment(item)" :disabled="incomedeclarations_loading"><v-icon>fas fa-paperclip</v-icon></v-btn>
					</v-badge>
				</template>
			</material-table>
		</material-card>
		<create-edit-incomedeclarations v-if="showCreateEditIncomeDeclarations"></create-edit-incomedeclarations>
		<import-incomedeclarations v-if="showImportIncomeDeclarations"></import-incomedeclarations>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originalincomedeclarations_options: null,
		selected_incomedeclarations: [],
	}),
	computed: {
		showImportIncomeDeclarations() {
			return this.$store.getters.showImportIncomeDeclarations;
		},
		dateFilterName() {
			if (this.incomedeclarations_options.date_start != null) {
				return "Date filtrate";
			}
			return null;
		},
		isCustomDateFilter() {
			if (this.incomedeclarations_options.datefiltertype) {
				return this.$appOptions.dateFilter(this.incomedeclarations_options.datefiltertype).value == "custom";
			}
			return false;
		},
		showCreateEditIncomeDeclarations() {
			return this.$store.getters.showCreateEditIncomeDeclarations;
		},
		main_action() {
			return {
				icon: "fas fa-plus",
				text: this.$vuetify.breakpoint.xsOnly ? this.$t("incomedeclarations.mainaction_mobile") : this.$t("incomedeclarations.mainaction"),
			};
		},
		incomedeclarations_headers() {
			let headers = [];
			headers.push({
				text: this.$t("incomedeclarations.ref_year"),
				value: "ref_year",
				align: "left",
				sortable: true,
				width: "1%",
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.tax"),
				value: "tax",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.contribute"),
				value: "contribute",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: this.$t("incomedeclarations.taxable"),
				value: "taxable",
				align: "center",
				sortable: true,
				selected: true,
			});
			headers.push({
				text: "",
				value: "attachments",
				align: "center",
				sortable: false,
				selected: true,
				width: "1%",
			});
			return { data: headers, id: "incomedeclarations_headers" };
		},
		incomedeclarations_options: {
			get: function () {
				return this.$store.getters.getIncomeDeclarationsOptions;
			},
			set: function (value) {
				this.$store.commit("setIncomeDeclarationsOptions", value);
			},
		},
		incomedeclarations() {
			return this.$store.getters.getIncomeDeclarations;
		},
		incomedeclarations_loading() {
			return this.$store.getters.incomedeclarations_loading;
		},
	},
	methods: {
		showIncomeDeclarationsAttachment(item) {
			this.$store.dispatch("setCurrentModelForAttachment", {
				object: item,
				filecategory: "incomedeclarations",
				show: true,
			});
		},
		updateDateFilter() {
			if (!this.isCustomDateFilter) {
				let options = _.cloneDeep(this.incomedeclarations_options);
				if (options.datefiltertype != null) {
					let dates = this.$appOptions.dateFilter(options.datefiltertype);
					options.date_start = dates.date_start;
					options.date_end = dates.date_end;
				} else {
					options.date_start = null;
					options.date_end = null;
				}
				this.incomedeclarations_options = options;
			}
		},
		loadIncomeDeclarations() {
			const self = this;
			if (self.$functions.ObjectAreEqual(self.originalincomedeclarations_options, self.incomedeclarations_options) == false) {
				self.originalincomedeclarations_options = _.cloneDeep(self.incomedeclarations_options);
				self.$store.dispatch("fetchIncomeDeclarations");
			}
		},
		newIncomeDeclarations(selected) {
			let isCopy = false;
			if (selected) {
				delete selected.id;
				isCopy = true;
			} else {
				selected = {
					ref_year: moment().format("YYYY"),
				};
			}
			this.$store.dispatch("setCurrentModelForAttachment", {
				object: selected,
				filecategory: "incomedeclarations",
			});
			this.$store.dispatch("showAction", "showCreateEditIncomeDeclarations");
		},
		editIncomeDeclarations(item) {
			this.$store.dispatch("setCurrentModelForAttachment", {
				object: item,
				filecategory: "incomedeclarations",
			});
			this.$store.dispatch("showAction", "showCreateEditIncomeDeclarations");
		},
		deleteIncomeDeclarations() {
			const self = this;
			let message = self.$t("global.delete_confirm_message_pre");
			if (self.selected_incomedeclarations.length <= 1) {
				message += self.$t("incomedeclarations.question_selected");
			} else {
				message += self.selected_incomedeclarations.length + self.$t("incomedeclarations.question_multiple_selected");
			}
			self.$store.commit("showDialog", {
				type: "confirm",
				title: self.$t("global.delete_confirm_title"),
				message: message,
				okCb: () => {
					self.selected_incomedeclarations.forEach((element) => {
						self.$store.dispatch("deleteIncomeDeclarations", element.id).then((res) => {
							self.$functions.actionOnSelection(res, self.selected_incomedeclarations);
						});
					});
				},
			});
		},
	},
	watch: {
		incomedeclarations_options: {
			handler(val) {
				this.loadIncomeDeclarations();
			},
			deep: true,
		},
	},
};
</script>
